// @flow
import { connect } from 'react-redux';
import SimReplacement from './SimReplacement';
import { initSimReplacement } from '../../modules/SignUp';
import { isLoadingSelector } from '../../modules/LoadingStatus';

import type { DispatchProps, StateProps } from './SimReplacement';
import type { StateType } from '../../modules/reducers';
import { hasVisibleSubscriptionsSelector } from '../../modules/Dashboard';
import { subscriptionsToActivateSelector } from '../../modules/Subscriptions';

const mapStateToProps = (state: StateType): StateProps => ({
  isLoading: isLoadingSelector(state, 'initSignUp'),
  hasVisibleSubscriptions: hasVisibleSubscriptionsSelector(state),
  hasSubscriptionToActivate: !!subscriptionsToActivateSelector(state).length,
});

const mapDispatchToProps: DispatchProps = {
  initSimReplacement,
};

export default connect(mapStateToProps, mapDispatchToProps)(SimReplacement);
